<template>
	<v-card class="d-flex pa-2" variant="outlined">
		<v-row align="center" justify="space-between" class="flex-nowrap">
			<v-col cols="6" class="d-flex justify-space-between align-center px-1">
				<div class="flex-column flex-xl-grow-1 text-xl-center">
					<v-icon size="28">mdi-timer-outline</v-icon>
				</div>
				<div id="timer-minutes" class="flex-column flex-xl-grow-1 text-center">
					<label class="text-body-2">Mins</label>
					<div class="text-h2 font-weight-bold">{{ minutes }}</div>
				</div>
				<div id="timer-seconds" class="flex-column flex-xl-grow-1 text-center">
					<label class="text-body-2">Secs</label>
					<div class="text-h2 font-weight-bold">{{ seconds }}</div>
				</div>
			</v-col>
			<v-col cols="auto">
				<v-btn v-if="timer" variant="outlined" class="mr-2 px-2" color="secondary" @click="reset">
					Reset
				</v-btn>
				<v-btn v-if="state !== 'running'" variant="outlined" class="px-2" color="secondary" @click="start">
					Start
				</v-btn>
				<v-btn v-if="state !== 'stopped'" variant="outlined" class="px-2" color="secondary" @click="stop">
					Stop
				</v-btn>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import moment from "moment-timezone";

export default {
	name: "Timer",

	data: () => ({
		state: "stopped",
		timer: 0,
		minutes: "00",
		seconds: "00",
		ticker: undefined
	}),

	methods: {
		start() {
			if (this.state !== "running") {
				this.tick();
				this.state = "running";
			}
		},

		reset() {
			this.timer = 0;
			this.minutes = "00";
			this.seconds = "00";
			if (this.ticker && this.state !== "running") {
				this.$worker.clearInterval(this.ticker);
				this.ticker = null;
			}
		},

		stop() {
			if (this.ticker) {
				this.$worker.clearInterval(this.ticker);
				this.ticker = null;
			}
			this.state = "stopped";
		},

		tick() {
			this.ticker = this.$worker.setInterval(() => {
				this.timer += 125;	//todo: why 125ms???
				this.minutes = moment.utc(this.timer).format("mm");
				this.seconds = moment.utc(this.timer).format("ss");
			}, 125);
		}
	},

	beforeUnmount() {
		if (this.ticker) {
			this.$worker.clearInterval(this.ticker);
			this.ticker = null;
		}
	}
}
</script>